/*
 *
 * DisputeUciTimeoutModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 04-Jun-2026
*/

import DisputeUciTimeoutModal from './DisputeUciTimeoutModalContainer'

export default DisputeUciTimeoutModal
